module.exports = __webpack_public_path__ + "static/img/cont48 (3).0012928.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont48 (3).jpg
// module id = KOT7
// module chunks = 0